/*
    作業者を選択するリスト
*/
import React from 'react';
import { GetWorkStatus } from "../../models/GetWorkStatus";

import './MemberSelectWithWorkStatusLabel.css';

export type ProcCodeSelectProp = {
    // 作業者名
    workerName: string;
    // 作業者ID
    workerMemberId: string;
    // 作業状況
    workStatuses: GetWorkStatus[]|null;
}
export const MemberSelectWithWorkStatusLabel: React.FC<ProcCodeSelectProp> = (
    { workerName, workerMemberId, workStatuses }) => {
        // 作業者の作業状況
        let workStatus:GetWorkStatus|null = null;
        if (workStatuses) {
            workStatus = workStatuses.find(d => d.member_id === workerMemberId) ?? null;
        }
        let statusName:string = "　";
        let styleClass:string = "work-status-none";
        if (workStatus) {
            switch(workStatus.status_code) {
                case 0:
                    statusName = "　";
                    styleClass = "none";
                    break;
                case 1:
                    statusName = "▶"; //
                    styleClass = "working";
                    break;
                case 2:
                    statusName = "⏸"; //
                    styleClass = "suspended";
                    break;
                case 3:
                    statusName = "▶";
                    styleClass = "working";
                    break;
                case 4: 
                    statusName = "　";
                    styleClass = "none";
                    break;
            }
        }
    
    return (
        <div className='work-status-select-label'>
            <div className={styleClass}>
                <span>
                    {statusName}
                </span>
                <span>
                    &nbsp;&nbsp;
                </span>
                <span>{workerName}</span>
            </div>
        </div>
    );
};